/* eslint-disable no-unused-vars */
export enum CredentialsEnum {
  SYSTEM_FULL_ACCESS = 'system-full-access'
}
